import styled from 'styled-components';
import { colourPalette, lineHeight } from 'styles/styles';

export const FullWidthTipStyle = {
  Container: styled.div`
    padding: 16px 24px;
    background-color: ${colourPalette.neutral100};
    border-radius: 6px;
    margin-bottom: 24px;
    header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      p {
        flex: 1 1 auto;
        margin: 0;
        padding: 0 8px;
        line-height: ${lineHeight.lineHeightMD};
        color: ${colourPalette.neutral600};
      }
      svg {
        flex: 0 0 24px;
        width: 24px;
        &.close {
          cursor: pointer;
          path {
            fill: ${colourPalette.neutral400};
          }
          &:hover path {
            fill: ${colourPalette.neutral600};
          }
        }
      }
    }
    section {
      p {
        margin: 0;
        color: ${colourPalette.neutral500};
        line-height: ${lineHeight.lineHeightMD};
      }
    }
  `,
};
